@if (data?.title) {
  <sd-title [titleLevel]="2" customClass="is-text-dark">
    {{ data.title }}
  </sd-title>
}
<div id="ShoppableContainer-{{uuid}}"></div>
